import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Copy.svg",
  "use": "Copy.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Copy.svg\"><path d=\"m41.0208 56.0208h-26a3 3 0 0 1 -3-3v-34a3 3 0 0 1 3-3h7v29a5 5 0 0 0 5 5h17v3a3 3 0 0 1 -3 3zm2-34a1 1 0 0 1 -1-1v-10.5858a1 1 0 0 1 1.7072-.7071l10.5856 10.5859a1 1 0 0 1 -.707 1.707zm13 5v18a3 3 0 0 1 -3 3h-26a3 3 0 0 1 -3-3v-34a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 1 3 3.0001z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol